"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tooltip = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Tooltip = ({
  className,
  title,
  position,
  children,
  id,
  ariaLabel,
  arrowStyle,
  tooltipStyle,
  ...rest
}) => {
  let baseClass = "sp-tooltip";
  let classes = (0, _classnames.default)(className, `${baseClass}`);
  const node = (0, _react.useRef)();
  let timer = null;
  const [showTooltip, setShowTooltip] = (0, _react.useState)(false);

  const handleHover = ({
    target
  }) => {
    if (node.current.contains(target)) {
      return;
    }
  };

  (0, _react.useEffect)(() => {
    document.addEventListener("mouseover", handleHover);
    window.addEventListener("scroll", onScroll); // called when unmounted

    return () => {
      document.removeEventListener("mouseover", handleHover);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const onScroll = () => {
    setShowTooltip(false);
  };

  const ariaProps = {
    "aria-label": ariaLabel
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    ref: node,
    onMouseOver: () => {
      setShowTooltip(true);
    },
    onMouseLeave: () => {
      setShowTooltip(false);
    }
  }, children, showTooltip && /*#__PURE__*/_react.default.createElement("div", _extends({}, ariaProps, {
    id: id,
    style: tooltipStyle,
    className: `${baseClass}--content tooltip--${position}`
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: arrowStyle,
    className: "arrow"
  }), title));
};

exports.Tooltip = Tooltip;
Tooltip.defaultProps = {
  position: "top",
  title: "tooltip placeholder"
};
Tooltip.propTypes = {
  className: _propTypes.default.string,
  position: _propTypes.default.oneOf(_utils.enums.tooltipPlacementPositions),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  id: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  arrowStyle: _propTypes.default.object,
  tooltipStyle: _propTypes.default.object,
  children: _propTypes.default.element.isRequired
};
var _default = Tooltip;
exports.default = _default;